module.exports = __webpack_public_path__ + "img/crab.c12e4f94.png";